import { mapGetters, mapState } from "vuex"

import data_input from "~/components/inputs/dataInput"
import reset_password from "~/components/auth/resetPassword"
import action_button from "~/components/shared/actionButton"
import heigh_expand from "~/components/transitions/heightExpand"

import login_mixin from "~/mixins/auth/login"
import acc_swap_mixin from "./loginMixin_acc_swap"
import validity_mixin from "./loginMixin_validity"
import facebook_mixin from "~/mixins/third_party/manipulation/facebook.js"

export default {
  components: { data_input, action_button, heigh_expand, reset_password },
  mixins: [validity_mixin, facebook_mixin, acc_swap_mixin, login_mixin],
  data: function () {
    return {
      email: "",
      password: "",
      errorOutput: "",
      loading: false,
      showpass: false,
    }
  },
  computed: {
    passType: function () {
      return this.showpass ? "text" : "password"
    },
    lState: function () {
      return this.$store.state.login
    },
    ...mapGetters({
      existing_user_is_valid: "login/EXISTING_USER_IS_VALID",
    }),
    ...mapState({
      swap_mode: (state) => state.login.swap_mode,
      swap_email: (state) => state.login.swap_email,
      existing_user: (state) => state.login.existing_user,
      displayRecovery: (state) => state.login.displayRecovery,
    }),
  },
  mounted: function () {
    if (this.swap_mode) this.email = this.swap_email
    if (this.existing_user_is_valid) this.email = this.existing_user.email
  },
  methods: {
    openRecovery: function () {
      this.$store.commit("login/SET_DISPLAY_RECOVERY", true)
    },
    ignorePrefetch: function () {
      this.$store.commit("login/RESET_EXISTING_USER")
    },
    probeLogin: function () {
      if (this.validate()) {
        this.handle_login()
      }
    },
    handle_login: function () {
      if (this.$store.state.login.swap_mode) this.addAccount()
      else this.login()
    },
    login: function () {
      this.postLoginInfos({
        email: this.email.toLowerCase().trim(),
        password: this.password,
      })
        .then((resp) => {
          this.sucHandle(resp)
        })
        .catch(() => {
          this.errHandle(1)
        })
    },
    facebookRoutine: function () {
      this.loading = true
      this.fbLogin()
        .then(() => {
          if (this.fbIsLoggedIn) {
            this.$axios
              .$post("/facebook/login/", {
                access_token: this.fbData.authResponse.accessToken,
              })
              .then((resp) => {
                if (this.$store.state.login.swap_mode) this.addAccount(true)
                else this.sucHandle(resp)
              })
              .catch(() => {
                this.errHandle(1)
              })
          } else this.errHandle(0)
        })
        .catch((err) => {
          this.$sentry.captureException(err)
          this.loading = false
        })
    },
    sucHandle: function (data) {
      this.loading = false
      this.$store.dispatch("login/SET_DISPLAY", false)
      if (data.is_staff === true)
        window.location.href = `${window.location.origin}/core/wWCjMFQu4MXMq7kBs6DryTu7FZHkARr/`
      this.$store.dispatch("USER_LOAD").then(() => {
        if (data.agency === null && data.influencer === null) {
          const bandSignupTimestamp = window.localStorage.getItem(
            "bandSignupTimestamp"
          )
          const influencerSignupTimestamp = window.localStorage.getItem(
            "influencerSignupTimestamp"
          )

          if (influencerSignupTimestamp > bandSignupTimestamp)
            this.$router.push("/influencer/signup/")
          else this.$router.push("/band/signup/")
        } else {
          this.$router.push("/")
        }
      })
    },
    errHandle: function (errNb) {
      const errorOutputs = [this.$t("auth.login09"), this.$t("auth.login10")]
      const err = errorOutputs[errNb]

      this.loading = false
      this.validity.email = false
      this.validity.password = false
      this.errorOutput = err || this.$t("common.error")
    },
    handleResetClose: function (closeAll) {
      this.$store.commit("login/SET_DISPLAY_RECOVERY", false)
      if (closeAll === true) this.$parent.$emit("close")
    },
    request_signup: function () {
      this.$store.dispatch("band_signup/SET_DISPLAY", true)
    },
  },
}
